<template>
  <div class="animated fadeIn" id="Hssk831-page-update">
    <div class="card">
      <div class="card-body p-4">
        <b-row class="mb-3">
          <b-col md="12" class="text-center bold">
            <h5 v-if="mData.viewMode == 'update'">
              CẬP NHẬP HỒ SƠ SỨC KHỎE CÁ NHÂN
            </h5>
            <h5 v-if="mData.viewMode == 'create'">
              THÊM MỚI HỒ SƠ SỨC KHỎE CÁ NHÂN
            </h5>
          </b-col>
          <div style="position: absolute; right: 24px; top: 15px">
            <el-button type="info" plain @click="fn_print"
              ><i class="el-icon-printer icons"></i> In</el-button
            >
            <el-button type="info" plain @click="fn_gotoDetail"
              >Quay lại</el-button
            >
          </div>
        </b-row>

        <!-- mục A -->
        <b-row class="mb-2">
          <b-col md="8" class="bold-500">
            <span @click="mData.showA = !mData.showA" class="link"
              >A. PHẦN THÔNG TIN HÀNH CHÍNH</span
            >
          </b-col>
        </b-row>

        <div>
          <el-form
            :model="mData.dataForm"
            :rules="mData.validForm"
            ref="myForm"
            label-width="100%"
            label-position="top"
          >
            <b-row>
              <div class="col-md-4">
                <el-form-item
                  label="Họ và tên:"
                  prop="ThongTinHanhChinh.HO_TEN"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.HO_TEN"
                    clearable
                  ></el-input>
                </el-form-item>
              </div>
              <b-col md="4">
                <el-form-item
                  label="Quan hệ với chủ hộ:"
                  prop="ThongTinHanhChinh.MOI_QH_CH"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.MOI_QH_CH"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Mã hộ GĐ:"
                  prop="ThongTinHanhChinh.MA_HOGD"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.MA_HOGD"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item
                  label="Giới tính:"
                  prop="ThongTinHanhChinh.GIOI_TINH"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.GIOI_TINH"
                    :placeholder="aLang.c_select"
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmGioiTinh"
                      :key="item.GIOI_TINH_Id"
                      :label="item.TEN_GIOI_TINH"
                      :value="item.GIOI_TINH_Id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>

              <b-col md="4">
                <el-form-item
                  label="Nhóm máu:"
                  prop="ThongTinHanhChinh.NHOM_MAU"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.NHOM_MAU"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item label="Nhóm RH:" prop="ThongTinHanhChinh.HE_RH">
                  <el-input
                    maxlength="3"
                    v-model="mData.dataForm.ThongTinHanhChinh.HE_RH"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item
                  label="Ngày sinh:"
                  prop="ThongTinHanhChinh.NGAY_SINH_new"
                >
                  <el-date-picker
                    type="date"
                    :format="aElement.datepicker.formatDate"
                    :valueFormat="aElement.datepicker.valueFormat"
                    v-model="mData.dataForm.ThongTinHanhChinh.NGAY_SINH_new"
                    :placeholder="aElement.datepicker.placeholderDate"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Tỉnh/TP đăng ký khai sinh:"
                  prop="ThongTinHanhChinh.NDKKS_MA_TINH"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.NDKKS_MA_TINH"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmTinhThanh"
                      :key="item.MA_TINH"
                      :label="item.TEN_TINH"
                      :value="item.MA_TINH"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <el-form-item label="Dân tộc:" prop="ThongTinHanhChinh.DAN_TOC">
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.DAN_TOC"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmDanToc"
                      :key="item.DAN_TOC_Id"
                      :label="item.TEN_DAN_TOC"
                      :value="item.DAN_TOC_Id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="3">
                <el-form-item
                  label="Quốc tịch:"
                  prop="ThongTinHanhChinh.MA_QGIA"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.MA_QGIA"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmQuocGia"
                      :key="item.MA_QGIA"
                      :label="item.ten_qg"
                      :value="item.MA_QGIA"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="3">
                <el-form-item
                  label="Tôn giáo:"
                  prop="ThongTinHanhChinh.TON_GIAO"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.TON_GIAO"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmTonGiao"
                      :key="item.TON_GIAO_Id"
                      :label="item.TEN_TON_GIAO"
                      :value="item.TON_GIAO_Id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="3">
                <el-form-item
                  label="Nghề nghiệp:"
                  prop="ThongTinHanhChinh.NGHE_NGHIEP"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.NGHE_NGHIEP"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item
                  label="Số CMND/CCCD:"
                  prop="ThongTinHanhChinh.CMND"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.CMND"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Ngày cấp:"
                  prop="ThongTinHanhChinh.NGAY_CAP"
                >
                  <el-date-picker
                    type="date"
                    :format="aElement.datepicker.formatDate"
                    :valueFormat="aElement.datepicker.valueFormat"
                    v-model="mData.dataForm.ThongTinHanhChinh.NGAY_CAP"
                    :placeholder="aElement.datepicker.placeholderDate"
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item label="Nơi cấp:" prop="ThongTinHanhChinh.NOI_CAP">
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.NOI_CAP"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <el-form-item
                  label="Mã định danh BHYT / Số thẻ BHYT:"
                  prop="ThongTinHanhChinh.SOTHEBHYT"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.SOTHEBHYT"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <el-form-item
                  label="Nơi đăng ký HKTT: (Thôn/xóm, số nhà, đường phố):"
                  prop="ThongTinHanhChinh.DIA_CHI_DKTT"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.DIA_CHI_DKTT"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item
                  label="Tỉnh/TP:"
                  prop="ThongTinHanhChinh.MA_TINH_THANH"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.MA_TINH_THANH"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                    @change="
                      fn_changeTinhThanh_thuongtru(
                        mData.dataForm.ThongTinHanhChinh.MA_TINH_THANH,
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmTinhThanh"
                      :key="item.MA_TINH"
                      :label="item.TEN_TINH"
                      :value="item.MA_TINH"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Quận/Huyện:"
                  prop="ThongTinHanhChinh.MA_QUAN_HUYEN"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.MA_QUAN_HUYEN"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                    @change="
                      fn_changeQuanHuyen_thuongtru(
                        mData.dataForm.ThongTinHanhChinh.MA_TINH_THANH,
                        mData.dataForm.ThongTinHanhChinh.MA_QUAN_HUYEN,
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmQuanHuyen_thuongtru"
                      :key="item.MA_QUAN"
                      :label="item.TEN_QUAN"
                      :value="item.MA_QUAN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Xã/Phường:"
                  prop="ThongTinHanhChinh.MA_PHUONG_XA"
                >
                  <el-select
                    v-model="mData.dataForm.ThongTinHanhChinh.MA_PHUONG_XA"
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmPhuongXa_thuongtru"
                      :key="item.MA_XA"
                      :label="item.TEN_XA"
                      :value="item.MA_XA"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <el-form-item
                  label="Nơi ở hiện tại: (Thôn/xóm, số nhà, đường phố):"
                  prop="ThongTinHanhChinh.DIA_CHI"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.DIA_CHI"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item
                  label="Tỉnh/TP:"
                  prop="ThongTinHanhChinh.NOI_O_MA_TINH_THANH"
                >
                  <el-select
                    v-model="
                      mData.dataForm.ThongTinHanhChinh.NOI_O_MA_TINH_THANH
                    "
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                    @change="
                      fn_changeTinhThanh_hientai(
                        mData.dataForm.ThongTinHanhChinh.NOI_O_MA_TINH_THANH,
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmTinhThanh"
                      :key="item.MA_TINH"
                      :label="item.TEN_TINH"
                      :value="item.MA_TINH"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>

              <b-col md="4">
                <el-form-item
                  label="Quận/Huyện:"
                  prop="ThongTinHanhChinh.NOI_O_MA_QUAN_HUYEN"
                >
                  <el-select
                    v-model="
                      mData.dataForm.ThongTinHanhChinh.NOI_O_MA_QUAN_HUYEN
                    "
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                    @change="
                      fn_changeQuanHuyen_hientai(
                        mData.dataForm.ThongTinHanhChinh.NOI_O_MA_TINH_THANH,
                        mData.dataForm.ThongTinHanhChinh.NOI_O_MA_QUAN_HUYEN,
                        true
                      )
                    "
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmQuanHuyen_hientai"
                      :key="item.MA_QUAN"
                      :label="item.TEN_QUAN"
                      :value="item.MA_QUAN"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>

              <b-col md="4">
                <el-form-item
                  label="Xã/Phường:"
                  prop="ThongTinHanhChinh.NOI_O_MA_PHUONG_XA"
                >
                  <el-select
                    v-model="
                      mData.dataForm.ThongTinHanhChinh.NOI_O_MA_PHUONG_XA
                    "
                    :placeholder="aLang.c_select"
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in mData.dataDefault.dmPhuongXa_hientai"
                      :key="item.MA_XA"
                      :label="item.TEN_XA"
                      :value="item.MA_XA"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <el-form-item
                  label="Điện thoại:"
                  prop="ThongTinHanhChinh.DIEN_THOAI"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.DIEN_THOAI"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Di động:"
                  prop="ThongTinHanhChinh.DIEN_THOAI_DD"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_DD"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item label="Email:" prop="ThongTinHanhChinh.EMAIL">
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.EMAIL"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <el-form-item
                  label="Họ tên mẹ:"
                  prop="ThongTinHanhChinh.HO_TEN_ME"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.HO_TEN_ME"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Họ tên bố:"
                  prop="ThongTinHanhChinh.HO_TEN_BO"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.HO_TEN_BO"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <el-form-item
                  label="Họ tên người chăm sóc chính (NCSC):"
                  prop="ThongTinHanhChinh.HO_TEN_NCSC"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.HO_TEN_NCSC"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Mối quan hệ:"
                  prop="ThongTinHanhChinh.MOI_QH_NCSC"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.MOI_QH_NCSC"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <el-form-item
                  label="Điện thoại (bố/ mẹ/ NCSC): Cố định:"
                  prop="ThongTinHanhChinh.DIEN_THOAI_NCSC"
                >
                  <el-input
                    v-model="mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_NCSC"
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
              <b-col md="4">
                <el-form-item
                  label="Di động:"
                  prop="ThongTinHanhChinh.DIEN_THOAI_DD_NCSC"
                >
                  <el-input
                    v-model="
                      mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_DD_NCSC
                    "
                    clearable
                  ></el-input>
                </el-form-item>
              </b-col>
            </b-row>
          </el-form>
        </div>

        <b-row class="mb-2">
          <b-col md="12" class="text-center">
            <el-button
              v-if="mData.viewMode == 'update'"
              type="info"
              plain
              @click="fn_updateA"
              >Cập nhật thông tin hành chính</el-button
            >
            <el-button
              v-if="mData.viewMode == 'create'"
              type="info"
              plain
              @click="fn_updateA"
              >Thêm mới thông tin hành chính</el-button
            >
            <el-button
              v-if="mData.viewMode == 'update' && mData.hasHssk_id"
              type="info"
              plain
              @click="fn_gotoStep2"
              >Cập nhật thông tin sức khỏe</el-button
            >
            <el-button
              v-if="mData.viewMode == 'create' && mData.hasHssk_id"
              type="info"
              plain
              @click="fn_gotoStep2"
              >Thêm mới thông tin sức khỏe</el-button
            >
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import KhaoSatApi from "../../../moduleApi/KhaoSatApi";
import Hssk831Api from "../../../moduleApi/Hssk831Api";
import COSApi from "../../../moduleApi/COSApi";
import Hssk831Model from "./HsskBNModel";
import moment from "moment";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "HsskBN",
        currentUser: MethodService.getCurrentUser(),
        listData: [],
        dataForm: MethodService.copyObject(Hssk831Model.dataForm),
        validForm: Hssk831Model.validForm,

        dataDefault: {
          HSSKCN_id: null,
          dmQuocGia: [],
          dmDanToc: [],
          dmTonGiao: [],
          dmGioiTinh: [],
          dmTinhThanh: [],
          dmQuanHuyen_thuongtru: [],
          dmPhuongXa_thuongtru: [],
          dmQuanHuyen_hientai: [],
          dmPhuongXa_hientai: [],
        },
        hasHssk_id: false,
      },
      tabIndex: [0, 0],
    };
  },

  methods: {
    Test(value, operation) {
      let patt = new RegExp(operation);
      return patt.test(value);
    },
    reloadAdress() {
      let MA_TINH_THANH = this.mData.dataForm.ThongTinHanhChinh.MA_TINH_THANH;
      let NOI_O_MA_TINH_THANH = this.mData.dataForm.ThongTinHanhChinh
        .NOI_O_MA_TINH_THANH;
      let MA_QUAN_HUYEN = this.mData.dataForm.ThongTinHanhChinh.MA_QUAN_HUYEN;
      let NOI_O_MA_QUAN_HUYEN = this.mData.dataForm.ThongTinHanhChinh
        .NOI_O_MA_QUAN_HUYEN;
      if (MA_TINH_THANH) {
        this.fn_changeTinhThanh_thuongtru(MA_TINH_THANH);
        if (MA_QUAN_HUYEN) {
          this.fn_changeQuanHuyen_thuongtru(MA_TINH_THANH, MA_QUAN_HUYEN);
        }
      }
      if (NOI_O_MA_TINH_THANH) {
        this.fn_changeTinhThanh_hientai(NOI_O_MA_TINH_THANH);
        if (NOI_O_MA_QUAN_HUYEN) {
          this.fn_changeQuanHuyen_hientai(
            NOI_O_MA_TINH_THANH,
            NOI_O_MA_QUAN_HUYEN,
            false
          );
        }
      }
    },
    async fn_getDataByCardCode() {
      try {
        if (this.$router.currentRoute.params.id) {
          let dataInfoBN = JSON.parse(
            sessionStorage.getItem(this.$router.currentRoute.params.id)
          );
          if (dataInfoBN) {
            this.mData.dataForm.ThongTinHanhChinh = Object.assign(dataInfoBN, {
              NGAY_SINH_new: `${dataInfoBN.NAM_SINH}-${dataInfoBN.THANG_SINH}-${dataInfoBN.NGAY_SINH}T00:00:00`,
              SOTHEBHYT: dataInfoBN.SoTheBHYT,
              MA_TINH_THANH: dataInfoBN.MA_TINH,
              NOI_O_MA_TINH_THANH: dataInfoBN.NOI_O_MA_TINH,
              MA_QUAN_HUYEN: dataInfoBN.MA_HUYEN,
              NOI_O_MA_QUAN_HUYEN: dataInfoBN.NOI_O_MA_HUYEN,
              MA_PHUONG_XA: dataInfoBN.MA_XA,
              NOI_O_MA_PHUONG_XA: dataInfoBN.NOI_O_MA_XA,
            });
            console.log(
              "this.mData.dataForm.ThongTinHanhChinh",
              this.mData.dataForm.ThongTinHanhChinh
            );
            this.mData.dataDefault.HSSKCN_id = null;
            this.reloadAdress();
          } else {
            if (!this.Test(this.$router.currentRoute.params.id, "-")) {
              let CardCode = this.$router.currentRoute.params.id;
              let res831 = await KhaoSatApi.getHSSK831(CardCode);
              if (res831 && res831.data && res831.data[0] && res831.data[0].ThongTinHanhChinh) {
                let dataInfoBNApi = res831.data[0].ThongTinHanhChinh;
                this.mData.dataForm.ThongTinHanhChinh = Object.assign(
                  dataInfoBNApi,
                  {
                    NGAY_SINH_new: `${dataInfoBNApi.NAM_SINH}-${dataInfoBNApi.THANG_SINH}-${dataInfoBNApi.NGAY_SINH}T00:00:00`,
                    SOTHEBHYT: dataInfoBNApi.SoTheBHYT,
                    MA_TINH_THANH: dataInfoBNApi.MA_TINH,
                    NOI_O_MA_TINH_THANH: dataInfoBNApi.NOI_O_MA_TINH,
                    MA_QUAN_HUYEN: dataInfoBNApi.MA_HUYEN,
                    NOI_O_MA_QUAN_HUYEN: dataInfoBNApi.NOI_O_MA_HUYEN,
                    MA_PHUONG_XA: dataInfoBNApi.MA_XA,
                    NOI_O_MA_PHUONG_XA: dataInfoBNApi.NOI_O_MA_XA,
                  }
                );
                console.log(
                  "this.mData.dataForm.ThongTinHanhChinh",
                  this.mData.dataForm.ThongTinHanhChinh
                );
                this.mData.dataDefault.HSSKCN_id = null;
                this.reloadAdress();
              } else {
                let res = await COSApi.GetInfoUser(CardCode);
                if (res && res.data && res.data.Data && res.data.Data[0]) {
                  let dataBhyt =
                    res.data.Data[0].Bhyts && res.data.Data[0].Bhyts[0]
                      ? res.data.Data[0].Bhyts[0]
                      : null;
                  let dataInforUser = res.data.Data[0];
                  let data = { ...this.mData.dataForm };
                  data.ThongTinHanhChinh.HO_TEN = dataInforUser.FullName;
                  data.ThongTinHanhChinh.DIEN_THOAI = dataInforUser.Phone;
                  data.ThongTinHanhChinh.NGAY_SINH_new = MethodService.NgaySinhSlice(
                    dataInforUser.Dob.toString()
                  );
                  data.ThongTinHanhChinh.DIA_CHI_DKTT = dataInforUser.Address;
                  data.ThongTinHanhChinh.CMND = dataInforUser.CmndNumber;
                  if (CardCode.length < 16) {
                    data.ThongTinHanhChinh.COS_MATHE_DANGKY = CardCode;
                  } else {
                    data.ThongTinHanhChinh.COS_MATHE = CardCode;
                  }
                  if (dataBhyt) {
                    data.ThongTinHanhChinh.SOTHEBHYT = dataBhyt.BhytNumber;
                  }
                }
              }
            } else {
              this.mData.dataDefault.HSSKCN_id = this.$router.currentRoute.params.id;
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async fn_initData() {
      if (this.mData.dataDefault.HSSKCN_id) {
        try {
          let res = await KhaoSatApi.GetHoSo831ByHSSKCN_ID(
            this.mData.dataDefault.HSSKCN_id
          );
          console.log("dataaaa", res);
          if (res) {
            res.data[0].ThongTinHanhChinh.DIEN_THOAI = res.data[0]
              .ThongTinHanhChinh.DIEN_THOAI
              ? "0" + res.data[0].ThongTinHanhChinh.DIEN_THOAI.substring(2)
              : "";
            res.data[0].ThongTinHanhChinh.DIEN_THOAI_DD = res.data[0]
              .ThongTinHanhChinh.DIEN_THOAI_DD
              ? "0" + res.data[0].ThongTinHanhChinh.DIEN_THOAI_DD.substring(2)
              : "";
            res.data[0].ThongTinHanhChinh.DIEN_THOAI_NCSC = res.data[0]
              .ThongTinHanhChinh.DIEN_THOAI_NCSC
              ? "0" + res.data[0].ThongTinHanhChinh.DIEN_THOAI_NCSC.substring(2)
              : "";
            res.data[0].ThongTinHanhChinh.DIEN_THOAI_DD_NCSC = res.data[0]
              .ThongTinHanhChinh.DIEN_THOAI_DD_NCSC
              ? "0" +
                res.data[0].ThongTinHanhChinh.DIEN_THOAI_DD_NCSC.substring(2)
              : "";
            this.mData.dataForm.ThongTinHanhChinh = Object.assign(
              res.data[0].ThongTinHanhChinh,
              {
                NGAY_SINH_new: `${res.data[0].ThongTinHanhChinh.namSinh}-${res.data[0].ThongTinHanhChinh.thangSinh}-${res.data[0].ThongTinHanhChinh.ngaySinh}T00:00:00`,
              }
            );
            this.mData.dataForm.ThongTinDieuTri = res.data[0].ThongTinDieuTri;
            this.mData.dataForm.KetQuaCanLamSang = res.data[0].KetQuaCanLamSang;
            this.reloadAdress();

            // else if(MA_TINH_THANH&&NOI_O_MA_TINH_THANH){
            //     let res_MA_TINH_THANH = await KhaoSatApi.LoadDMQuanHuyen(MA_TINH_THANH);
            //     let res_NOI_O_MA_TINH_THANH = await KhaoSatApi.LoadDMQuanHuyen(NOI_O_MA_TINH_THANH);
            //     this.mData.dataDefault.dmQuanHuyen_thuongtru =  res_MA_TINH_THANH.data;
            //     this.mData.dataDefault.dmQuanHuyen_hientai =  res_NOI_O_MA_TINH_THANH.data;
            //     if(MA_QUAN_HUYEN && !NOI_O_MA_QUAN_HUYEN){
            //     this.fn_changeQuanHuyen_thuongtru(MA_QUAN_HUYEN)
            //   }else if(NOI_O_MA_QUAN_HUYEN && !MA_QUAN_HUYEN){
            //     this.fn_changeQuanHuyen_hientai(NOI_O_MA_QUAN_HUYEN)
            //   }else{
            //     let res_MA_QUAN_HUYEN = await KhaoSatApi.LoadDMPhuongXa(MA_TINH_THANH, MA_QUAN_HUYEN);
            //      let res_NOI_O_MA_QUAN_HUYEN = await KhaoSatApi.LoadDMPhuongXa(NOI_O_MA_TINH_THANH, NOI_O_MA_QUAN_HUYEN);
            //        this.mData.dataDefault.dmPhuongXa_thuongtru = res_MA_QUAN_HUYEN.data;
            //        this.mData.dataDefault.dmPhuongXa_hientai = res_NOI_O_MA_QUAN_HUYEN.data;
            //   }
            // }
          }
        } catch (error) {
          window.Swal.fire({
            icon: "error",
            text: "lỗi tải dư liệu!",
          });
        }
      }
    },
    async fn_initDataDefault() {
      let req_LoadDMQuocGia = KhaoSatApi.LoadDMQuocGia();
      let req_LoadDMDanToc = KhaoSatApi.LoadDMDanToc();
      let req_LoadDMGioiTinh = KhaoSatApi.LoadDMGioiTinh();
      let req_LoadDMTonGiao = KhaoSatApi.LoadDMTonGiao();
      let req_LoadDMTinhThanh = KhaoSatApi.LoadDMTinhThanh();

      let res_LoadDMQuocGia = await req_LoadDMQuocGia;
      let res_LoadDMDanToc = await req_LoadDMDanToc;
      let res_LoadDMGioiTinh = await req_LoadDMGioiTinh;
      let res_LoadDMTonGiao = await req_LoadDMTonGiao;
      let res_LoadDMTinhThanh = await req_LoadDMTinhThanh;

      await this.fn_getDataByCardCode();

      if (this.mData.dataDefault.HSSKCN_id) {
        this.mData.hasHssk_id = true;
        this.fn_initData();
      } else {
        this.mData.dataDefault.HSSKCN_id = MethodService.createGuid();
      }

      this.mData.dataDefault.dmQuocGia =
        res_LoadDMQuocGia && res_LoadDMQuocGia.data
          ? res_LoadDMQuocGia.data
          : [];

      this.mData.dataDefault.dmTonGiao =
        res_LoadDMTonGiao && res_LoadDMTonGiao.data
          ? res_LoadDMTonGiao.data
          : [];

      this.mData.dataDefault.dmDanToc =
        res_LoadDMDanToc && res_LoadDMDanToc.data ? res_LoadDMDanToc.data : [];

      this.mData.dataDefault.dmGioiTinh =
        res_LoadDMGioiTinh && res_LoadDMGioiTinh.data
          ? res_LoadDMGioiTinh.data
          : [];

      this.mData.dataDefault.dmTinhThanh =
        res_LoadDMTinhThanh && res_LoadDMTinhThanh.data
          ? res_LoadDMTinhThanh.data
          : [];
    },
    fn_formatDate(date) {
      return MethodService.formatDate(date, "date");
    },

    async fn_changeTinhThanh_thuongtru(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.dataForm.ThongTinHanhChinh.MA_QUAN_HUYEN = null;
        this.mData.dataForm.ThongTinHanhChinh.MA_PHUONG_XA = null;
      }
      let res = await KhaoSatApi.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmQuanHuyen_thuongtru = res.data;
    },

    async fn_changeQuanHuyen_thuongtru(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.dataForm.ThongTinHanhChinh.MA_PHUONG_XA = null;
      }
      let res = await KhaoSatApi.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmPhuongXa_thuongtru = res.data;
    },

    async fn_changeTinhThanh_hientai(MaTinhThanh, isReset) {
      if (isReset) {
        this.mData.dataForm.ThongTinHanhChinh.NOI_O_MA_QUAN_HUYEN = null;
        this.mData.dataForm.ThongTinHanhChinh.NOI_O_MA_PHUONG_XA = null;
      }
      let res = await KhaoSatApi.LoadDMQuanHuyen(MaTinhThanh);
      this.mData.dataDefault.dmQuanHuyen_hientai = res.data;
    },

    async fn_changeQuanHuyen_hientai(MaTinhThanh, MaQuanHuyen, isReset) {
      if (isReset) {
        this.mData.dataForm.ThongTinHanhChinh.NOI_O_MA_PHUONG_XA = null;
      }
      let res = await KhaoSatApi.LoadDMPhuongXa(MaTinhThanh, MaQuanHuyen);
      this.mData.dataDefault.dmPhuongXa_hientai = res.data;
    },

    async fn_updateA() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = {
            // cos_mathe: this.mData.currentUser.account,
            HSSK_Id: this.mData.dataDefault.HSSKCN_id,
            HO_TEN: this.mData.dataForm.ThongTinHanhChinh.HO_TEN,
            MOI_QH_CH: this.mData.dataForm.ThongTinHanhChinh.MOI_QH_CH,
            MA_HOGD: this.mData.dataForm.ThongTinHanhChinh.MA_HOGD,
            GIOI_TINH: this.mData.dataForm.ThongTinHanhChinh.GIOI_TINH,
            NHOM_MAU: this.mData.dataForm.ThongTinHanhChinh.NHOM_MAU,
            HE_RH: this.mData.dataForm.ThongTinHanhChinh.HE_RH,
            NDKKS_MA_TINH: this.mData.dataForm.ThongTinHanhChinh.NDKKS_MA_TINH,
            DAN_TOC: this.mData.dataForm.ThongTinHanhChinh.DAN_TOC,
            MA_QGIA: this.mData.dataForm.ThongTinHanhChinh.MA_QGIA,
            TON_GIAO: this.mData.dataForm.ThongTinHanhChinh.TON_GIAO,
            NGHE_NGHIEP: this.mData.dataForm.ThongTinHanhChinh.NGHE_NGHIEP,
            CMND: this.mData.dataForm.ThongTinHanhChinh.CMND,
            NGAY_CAP: this.mData.dataForm.ThongTinHanhChinh.NGAY_CAP,
            NOI_CAP: this.mData.dataForm.ThongTinHanhChinh.NOI_CAP,
            // SOTHEBHYT: this.mData.dataForm.ThongTinHanhChinh.SOTHEBHYT,
            DIA_CHI_DKTT: this.mData.dataForm.ThongTinHanhChinh.DIA_CHI_DKTT,
            MA_TINH: this.mData.dataForm.ThongTinHanhChinh.MA_TINH_THANH,
            MA_HUYEN: this.mData.dataForm.ThongTinHanhChinh.MA_QUAN_HUYEN,
            MA_XA: this.mData.dataForm.ThongTinHanhChinh.MA_PHUONG_XA,
            DIA_CHI: this.mData.dataForm.ThongTinHanhChinh.DIA_CHI,
            NOI_O_MA_TINH: this.mData.dataForm.ThongTinHanhChinh
              .NOI_O_MA_TINH_THANH,
            NOI_O_MA_HUYEN: this.mData.dataForm.ThongTinHanhChinh
              .NOI_O_MA_QUAN_HUYEN,
            NOI_O_MA_XA: this.mData.dataForm.ThongTinHanhChinh
              .NOI_O_MA_PHUONG_XA,
            DIEN_THOAI: this.mData.dataForm.ThongTinHanhChinh.DIEN_THOAI
              ? "84" +
                this.mData.dataForm.ThongTinHanhChinh.DIEN_THOAI.substring(1)
              : "",
            DIEN_THOAI_DD: this.mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_DD
              ? "84" +
                this.mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_DD.substring(1)
              : "",
            EMAIL: this.mData.dataForm.ThongTinHanhChinh.EMAIL,
            HO_TEN_ME: this.mData.dataForm.ThongTinHanhChinh.HO_TEN_ME,
            HO_TEN_BO: this.mData.dataForm.ThongTinHanhChinh.HO_TEN_BO,
            HO_TEN_NCSC: this.mData.dataForm.ThongTinHanhChinh.HO_TEN_NCSC,
            MOI_QH_NCSC: this.mData.dataForm.ThongTinHanhChinh.MOI_QH_NCSC,
            DIEN_THOAI_NCSC: this.mData.dataForm.ThongTinHanhChinh
              .DIEN_THOAI_NCSC
              ? "84" +
                this.mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_NCSC.substring(
                  1
                )
              : "",
            DIEN_THOAI_DD_NCSC: this.mData.dataForm.ThongTinHanhChinh
              .DIEN_THOAI_DD_NCSC
              ? "84" +
                this.mData.dataForm.ThongTinHanhChinh.DIEN_THOAI_DD_NCSC.substring(
                  1
                )
              : "",
            NGAY_SINH: "",
            THANG_SINH: "",
            NAM_SINH: "",
          };

          if (this.mData.dataForm.ThongTinHanhChinh.NGAY_SINH_new) {
            data.NGAY_SINH = MethodService.getDay(
              this.mData.dataForm.ThongTinHanhChinh.NGAY_SINH_new
            );
            data.THANG_SINH = MethodService.getMonth(
              this.mData.dataForm.ThongTinHanhChinh.NGAY_SINH_new
            );
            data.NAM_SINH = MethodService.getYear(
              this.mData.dataForm.ThongTinHanhChinh.NGAY_SINH_new
            );
          }
          console.log(data);

          let res = await KhaoSatApi.updateHSSKCN(data);
          if (res.data) {
            this.mData.hasHssk_id = true;

            if (this.mData.dataForm.ThongTinHanhChinh.SOTHEBHYT) {
              this.fn_updateBHYT();
            } else {
              if (this.mData.viewMode == "update") {
                window.toastr.success("Cập nhật thành công");
              } else {
                window.toastr.success("Thêm mới thành công");
              }
            }
          } else {
            if (this.mData.viewMode == "update") {
              window.toastr.success("Cập nhật không thành công");
            } else {
              window.toastr.success("Thêm mới không thành công");
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    async fn_updateBHYT() {
      let arrObject = [];

      arrObject.push({
        HSSK_Id: this.mData.dataDefault.HSSKCN_id,
        BHYT_ID: this.mData.dataDefault.HSSKCN_id,
        MA_THE: this.mData.dataForm.ThongTinHanhChinh.SOTHEBHYT,
      });

      let res = await KhaoSatApi.updateBHYT(arrObject);
      if (res.data == true) {
        window.toastr.success("Cập nhật thành công");
      } else {
        window.toastr.error("Cập nhật số thẻ bảo hiếm y tế không thành công");
      }
    },

    fn_gotoDetail() {
      this.$router.push({ name: "Admin-HsskBN-list" });
    },

    fn_gotoStep2() {
      if (this.mData.viewMode == "update") {
        this.$router.push({
          name: "Admin-HsskBN-update-sk",
          params: { id: this.mData.dataDefault.HSSKCN_id },
        });
      } else {
        this.$router.push({
          name: "Admin-HsskBN-create-sk",
          params: { id: this.mData.dataDefault.HSSKCN_id },
        });
      }
    },
    fn_print() {
      window.print();
    },
  },

  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
  },
  async mounted() {
    await this.fn_initDataDefault();
    // this.fn_initData();
  },
};
</script>
<style scoped>
</style>